var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroAnnouncementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7617L12.694 17.9277C12.919 19.2807 11.876 20.5117 10.505 20.5117V20.5117C9.42 20.5117 8.494 19.7277 8.316 18.6567L7.5 13.7617",
    stroke: "#FF9A3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.7617H6.375C4.511 13.7617 3 12.2507 3 10.3867V10.3867C3 8.52272 4.511 7.01172 6.375 7.01172H14.25",
    stroke: "#FF9A3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.01187L19.251 3.67787C19.999 3.17987 21 3.71587 21 4.61487V16.1599C21 17.0589 19.999 17.5939 19.251 17.0959L14.25 13.7619",
    stroke: "#FF9A3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 13.7598V7.00977",
    stroke: "#FF9A3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroAnnouncementsIcon);
export default __webpack_public_path__ + "static/media/payro-announcements-icon.0c0534bd63497913c8edf832af32f109.svg";
export { ForwardRef as ReactComponent };